export { default } from './AlignmentDetailsPopup';
